const API = process.env.REACT_APP_API_BASE_URL || '';

const jsonFetch = async (url, opts = {}) => {
  const res = await fetch(url, { headers: { 'Content-Type': 'application/json' }, ...opts });
  const data = await res.json().catch(() => ({ message: 'Parse error' }));
  if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
  return data;
};

export const getParks = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return jsonFetch(`${API}/api/park-verification/parks?${qs}`);
};

export const getParkDetail = (aboneno) =>
  jsonFetch(`${API}/api/park-verification/detail?aboneno=${encodeURIComponent(aboneno)}`);

export const saveVerification = (data) =>
  jsonFetch(`${API}/api/park-verification/save`, { method: 'POST', body: JSON.stringify(data) });

export const getStats = () =>
  jsonFetch(`${API}/api/park-verification/stats`);

export const getMappings = (search = '') => {
  const qs = search ? `?search=${encodeURIComponent(search)}` : '';
  return jsonFetch(`${API}/api/park-verification/mappings${qs}`);
};

export const getHistory = (aboneno) => {
  const qs = aboneno ? `?aboneno=${encodeURIComponent(aboneno)}` : '';
  return jsonFetch(`${API}/api/park-verification/history${qs}`);
};

export const initTable = () =>
  jsonFetch(`${API}/api/park-verification/init`, { method: 'POST' });

export const getDbParks = (search = '') => {
  const qs = search ? `?search=${encodeURIComponent(search)}` : '';
  return jsonFetch(`${API}/api/park-verification/db-parks${qs}`);
};

export const getMatchReport = () =>
  jsonFetch(`${API}/api/park-verification/match-report`);

export const linkPark = (data) =>
  jsonFetch(`${API}/api/park-verification/link`, { method: 'POST', body: JSON.stringify(data) });
